// @flow

import * as React from "react";
import { useSelector } from "react-redux";

import { getCart } from "../actions/cart";

import HeroCheckout from "../components/organisms/HeroCheckout";
import CartSummary from "../components/molecules/CartSummary";
import CartItem from "../components/molecules/CartItem";
import ShopFooter from "../components/organisms/ShopFooter";
import CustomMeta from "../components/atoms/CustomMeta";

const Cart = (): React.Node => {
    const cart = useSelector((state: any): any => state.cart);

    const subTotal = cart.totals
        ? Number(cart.totals.total_items) + Number(cart.totals.total_items_tax)
        : null;

    const total = cart.totals
        ? subTotal -
          (Number(cart.totals.total_discount) +
              Number(cart.totals.total_discount_tax))
        : null;

    return (
        <div className="checkout-page">
            <CustomMeta title="Cart" />

            <HeroCheckout heading="Cart" />

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        {cart.items && cart.items.length
                            ? cart.items.map((cartItem: any, index: number) => {
                                  return (
                                      <CartItem
                                          key={index}
                                          {...cartItem}
                                          cartKey={cartItem.key}
                                      />
                                  );
                              })
                            : "You don’t have any items in your cart."}
                    </div>

                    <div className="col-xs-12 col-sm-6 col-lg-5 col-lg-offset-1">
                        <CartSummary
                            itemsCount={cart.items_count}
                            deliveryRequired={cart.needs_shipping}
                            promoCodes={cart.coupons}
                            subTotal={subTotal}
                            total={total}
                        />
                    </div>
                </div>
            </div>

            <ShopFooter />
        </div>
    );
};

Cart.preload = ({ passed: { store }, location }: any): Promise<any> => {
    return Promise.all([store.dispatch(getCart())]);
};

export default Cart;
